import moment from 'moment';
import { getCurrentDateTime } from './getCurrentDateTime';

export const getReportNameSuffix = org_TZ => {
	const orgTime = getCurrentDateTime(org_TZ);

	return moment(orgTime?.DateTime).format('MMMM DD YYYY hh:mm:ss');
};
